import { type GalleryCarouselImageItem } from '@lib/gallery'

import Photo from '@components/photo'

interface GalleryCarouselSlideImageProps {
  index: number
  item: GalleryCarouselImageItem
  preload?: boolean
  onClick?: (index: number) => void
}

const GalleryCarouselSlideImage = ({
  index,
  item,
  preload,
  onClick,
}: GalleryCarouselSlideImageProps) => {
  return (
    <div
      onClick={() => {
        if (onClick) {
          onClick(index)
        }
      }}
      className="carousel-slide relative flex flex-grow-0 flex-shrink-0 w-full min-h-full overflow-hidden justify-center"
    >
      <Photo image={item.image} priority={preload} />
    </div>
  )
}

export default GalleryCarouselSlideImage
